import React, { useEffect, useState, useRef } from "react";
import {
  FaceDetector as MediapipeFaceDetector,
  FilesetResolver,
} from "@mediapipe/tasks-vision";

interface FaceDetectorProps {
  onFaceDetected: () => void;
  webcamId?: string;
}

const runningMode = "VIDEO";
let lastVideoTime = -1;

const FaceDetector = ({
  onFaceDetected,
  webcamId,
}: FaceDetectorProps): JSX.Element => {
  const [faceDetector, setFaceDetector] = useState<
    MediapipeFaceDetector | undefined
  >();
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const initializefaceDetector = async () => {
      const vision = await FilesetResolver.forVisionTasks(
        "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm"
      );
      const newFaceDetector = await MediapipeFaceDetector.createFromOptions(
        vision,
        {
          baseOptions: {
            modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite`,
            delegate: "GPU",
          },
          runningMode: runningMode,
        }
      );

      newFaceDetector && setFaceDetector(newFaceDetector);
    };

    initializefaceDetector();
  }, []);

  const predictWebcam = async () => {
    if (faceDetector && videoRef.current) {
      let startTimeMs = performance.now();

      // Detect faces using detectForVideo
      if (videoRef.current.currentTime !== lastVideoTime) {
        lastVideoTime = videoRef.current.currentTime;
        const detections = faceDetector.detectForVideo(
          videoRef.current,
          startTimeMs
        ).detections;

        if (detections.length) {
          const score = detections[0].categories[0].score
          console.log('score : ', score)
          score > 0.9 && onFaceDetected();
        }
      }
    }

    // Call this function again to keep predicting when the browser is ready
    window.requestAnimationFrame(predictWebcam);
  };

  useEffect(() => {
    if (faceDetector && videoRef.current) {
      const constraints = {
        video: webcamId
          ? {
              deviceId: webcamId,
            }
          : true,
      };

      // Activate the webcam stream.
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
            videoRef.current.addEventListener("loadeddata", predictWebcam);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [faceDetector]);

  return (
    <React.Fragment>
      <video
        ref={videoRef}
        src=""
        autoPlay
        className="absolute top-0 left-0 w-full h-full z-[-1]"
      />
    </React.Fragment>
  );
};

export default FaceDetector;
